/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import styled from '@emotion/styled';
import { useTheme } from 'emotion-theming';
import { TransitionGlobal } from '../../../../shared/GlobalStyles';
import Text from '../../../../shared/components/Text/Text';
import { setNonDateBasedProgramDays, setSelectedProgramDayNumber, setSelectedNumberOfDaysToShowInWeek } from '../../ducks/calendarActions';

const WeekButtonWrapper = styled('div')`
  display: flex;
  width: 100%;
  padding: 4px;
  justify-content: space-between;
  :hover {
    background: ${(props) => props.viewType === 'weekView' && props.theme.colors.surfaceSecondary};
    cursor: ${(props) => props.viewType === 'weekView' && 'pointer'};
  }
`;

const DayButtonWrapper = styled('div')`
  display: flex;
  width: 100%;
  padding-left: 8px;
  padding-right: 8px;
  justify-content: space-between;
  :hover {
        background: ${(props) => props.viewType === 'dayView' && props.theme.colors.surfaceSecondary};
    cursor: ${(props) => props.viewType === 'dayView' && 'pointer'};
  }
`;
const OpacityWrapper = styled('div')`
display: flex;
 transition: ${TransitionGlobal};
    :hover {
      opacity: 0.7;
    }
`;

const GroupByDaySideBarContent = () => {
  const dispatch = useDispatch();
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const nonDateBasedProgramItems = useSelector(
    (state) => state.calendar.data.nonDateBasedProgramItems,
  );

  /** Step 1: build a grouped array manually using Object.values + find */
  const groupedDays = [];

  Object.values(nonDateBasedProgramItems || {}).forEach((item) => {
    const existingDayInWeek = groupedDays.find((d) => d.dayInWeek === item.dayInWeek);

    if (existingDayInWeek) {
      existingDayInWeek.weeks.push(item);
    } else {
      groupedDays.push({
        dayInWeek: item.dayInWeek,
        dayNumber: item.dayNumber,
        weeks: [item],
      });
    }
  });

  /** Step 2: sort days in each week */
  const sortedGroupedDays = groupedDays.map((day) => ({
    ...day,
    weeks: [...day.weeks].sort((a, b) => a.weekNumber - b.weekNumber),
  }));

  const handleDayButtonClick = (day) => {
    if (viewType === 'weekView') {
      const { dayNumber } = day;
      dispatch(setSelectedProgramDayNumber(dayNumber));
    }
  };

  const handleAddWeek = (day) => {
    const lastWeek = day.weeks[day.weeks?.length - 1];
    /** Prevent user from adding more than 52 weeks */
    if (lastWeek.weekNumber >= 52) return;

    /** Copy existing dictionary */
    const updatedItems = { ...nonDateBasedProgramItems };

    const newWeekNumber = lastWeek.weekNumber + 1;

    /** Add new days for the next week, from dayInWeek 1 up to day.dayInWeek */
    for (let d = 1; d <= day.dayInWeek; d++) {
    /** Calculate a unique key for the day — could be dayNumber or weekNumber + dayInWeek */
      const newDayNumber = newWeekNumber * 7 + d; /** sequential day number */

      /** Check if this day already exists in updatedItems */
      const dayAlreadyExists = Object.values(updatedItems).some(
        (item) => item.weekNumber === newWeekNumber && item.dayInWeek === d,
      );

      if (!dayAlreadyExists) {
        const newDay = {
          dayInWeek: d,
          dayNumber: newDayNumber,
          exercises: [],
          repCount: 0,
          setCount: 0,
          weekNumber: newWeekNumber,
          isLocalItem: true,
        };

        updatedItems[newDayNumber] = newDay;
      } else {
        console.log(`dayInWeek ${d} for week ${newWeekNumber} already exists, skipping`);
      }
    }

    /** Update Redux */
    dispatch(setNonDateBasedProgramDays(updatedItems));
    dispatch(setSelectedNumberOfDaysToShowInWeek(newWeekNumber));
  };

  const { colors } = useTheme();
  return (
    <>
      {sortedGroupedDays.map((day) => (
        <React.Fragment key={day.dayInWeek}>
          <WeekButtonWrapper
            style={{
              backgroundColor:
              viewType === 'weekView'
              && day.weeks.some((week) => week.dayNumber === selectedProgramDayNumber)
                ? colors.surfaceSecondary
                : undefined,
            }}
            viewType={viewType}
            onClick={() => handleDayButtonClick(day)}
          >
            <Text fontSize='16px' fontWeight='700'>{`Day ${day.dayInWeek}`}</Text>
            <OpacityWrapper>
              <Text
                fontSize='16px'
                color={colors.hover}
                style={{
                  cursor: day?.weeks?.length >= 7 ? 'pointer' : 'pointer',
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleAddWeek(day);
                }}
              >
                + Add Week
              </Text>
            </OpacityWrapper>
          </WeekButtonWrapper>
          {day.weeks.map((week) => (
            <DayButtonWrapper
              style={{ backgroundColor: selectedProgramDayNumber === week.dayNumber && viewType === 'dayView' && colors.surfaceSecondary }}
              key={day.dayNumber}
              viewType={viewType}
            >
              <Text fontSize='16px'>
                {`Week ${week.weekNumber}`}
              </Text>
              <OpacityWrapper>
                <Text
                  fontSize='16px'
                  color={colors.textSecondary}
                >
                  {week.exercises?.length || 0}
                  {' '}
                  Items
                </Text>
              </OpacityWrapper>
            </DayButtonWrapper>
          ))}
        </React.Fragment>
      ))}
    </>
  );
};

export default GroupByDaySideBarContent;
